import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ProductSearchResult } from '../services/products/products.service';

interface FavoritesState {
  items: ProductSearchResult[];
  addFavorite: (product: ProductSearchResult) => void;
  removeFavorite: (productId: string) => void;
  toggleFavorite: (product: ProductSearchResult) => void;
  isFavorite: (productId: string) => boolean;
  clearFavorites: () => void;
}

export const useFavoritesStore = create<FavoritesState>()(
  persist(
    (set, get) => ({
      items: [],

      addFavorite: (product) => {
        const exists = get().items.some((item) => item.id === product.id);
        if (!exists) {
          set((state) => ({ items: [...state.items, product] }));
        }
      },

      removeFavorite: (productId) => {
        set((state) => ({
          items: state.items.filter((item) => item.id !== productId),
        }));
      },

      toggleFavorite: (product) => {
        const isFav = get().isFavorite(product.id);
        if (isFav) {
          get().removeFavorite(product.id);
        } else {
          get().addFavorite(product);
        }
      },

      isFavorite: (productId) => {
        return get().items.some((item) => item.id === productId);
      },

      clearFavorites: () => set({ items: [] }),
    }),
    {
      name: 'favorites-storage',
    }
  )
);
